import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import PDFViewer from 'pdf-viewer-reactjs'
import { useHistory, useLocation } from 'react-router-dom';

import {
  ModalContent,
  PolicyTitle,
  DivisionCheckbox,
  DocumentContainer
} from "./styles";

import "~/components/styles/Global.css";
import "~/components/styles/Contracts.css";
import { useDispatch } from "react-redux";
import api from '~/services/api';
import CustomNavigation from "~/components/pages/Contracts/CustomNavigation";
import Loading from "~/components/layout/Loading";
import CheckBox from "~/components/layout/CheckBoxCustom";

export default function PrivacyPolicy({
  showModal,
  activeModal,
  access_token,
  user,
  fileData
}) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [termsOfCondition, setTermsOfCondition] = useState(false);
  const [attachment, setAttachment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(showModal);

  function getPolicyPrivacy() {
    if (fileData && fileData.file) {
      setAttachment(fileData.file);
      setLoading(false);
      return;
    }

    const header = {
      'Content-Type': 'application/json',
      access_token: access_token ? access_token : localStorage.getItem("access_token")
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    api.get("/residential/store/v1/files?type=POLITICA_PRIVACIDADE", parameters)
    .then((res) => {
      setAttachment(res.data.file);
      setLoading(false);
    })
    .catch((err) => {})
  }

  useEffect(() => {
    if(modalOpen) {
      setLoading(true);
      getPolicyPrivacy();
    }
  }, [modalOpen]);

  function handlePrivacy() {
    setLoading(false);
    setModalOpen(false);
    localStorage.setItem("privacyPolicy", true);
    dispatch({ type: "SET_POLICY", acceptPolicy: true })
  }

  return (
    <Modal
      show={modalOpen}
      onHide={() => {
        activeModal(false);
      }}
      className="modal-contrato"
      centered={window.screen.width >= 768}
      scrollable={true}
    >
      <Modal.Body scrollable={true} style={{ 
        overflow: window.screen.width > 770 ? "scroll" : "hidden", 
        padding: ".5rem", 
        borderRadius: 15 
      }}>
        {
          loading ? <Loading margin="100% auto" /> : (
          <ModalContent>
            <PolicyTitle>Política de privacidade</PolicyTitle>
            {
              loading || attachment === null ? <Loading margin="100% auto" /> : (
                <DocumentContainer>
                  <PDFViewer
                    css="viewr"
                    document={{
                      base64: attachment,
                    }}
                    navigation={CustomNavigation} 
                    loader={<Loading margin="100% auto" />}
                    navbarOnTop               
                  />
                    <DivisionCheckbox>
                      <div className="message">
                        {[{ checked: termsOfCondition }].map(store => (
                          <CheckBox
                            checked={termsOfCondition}
                            className="checkbox"
                            label={`Li e entendi a Política de Privacidade da Ultragaz e concordo com seus termos`}
                            title={`Li e entendi a Política de Privacidade da Ultragaz e concordo com seus termos`}
                            onChange={() => setTermsOfCondition(!termsOfCondition)}
                          />
                        ))}
                      </div>
                      <div>
                        <button 
                        checked={termsOfCondition}
                        onClick={() => {
                          if(termsOfCondition) {
                            setLoading(true);
                            handlePrivacy();
                          }
                        }}>Confirmar</button>
                      </div>
                    </DivisionCheckbox>
                </DocumentContainer>
              )
            }
          </ModalContent>
          )
        }
      </Modal.Body>
    </Modal>
  );
}
